import React,{useRef,useState,useEffect} from "react";
import BookingForm from "./bookingForm/bookingForm";
import BookingInfo from "./bookingInfo/BookingInfo";
import { useStateValue } from "../../StateProvider";
import {
  Grid, GridRow,Header,
} from "semantic-ui-react";
import ModalBuilder from "../modal/ModalBuilder"
const StepThree = ({setPage}) => {
  const [state, dispatch] = useStateValue();
  const { service, availableServices, date, time } = state;
const [isTimeUp, setIsTimeup] = useState(false);
  const Ref = useRef(null);
  
  // The state for our timer
  const [timer, setTimer] = useState('00:00:01');

  const getTimeRemaining = (e) => {
    const total = Date.parse(e) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / 1000 * 60 * 60) % 24);
    return {
        total, hours, minutes, seconds
    };
  }
    const startTimer = (e) => {
      let { total, hours, minutes, seconds } 
                  = getTimeRemaining(e);
      if (total >= 0) {

          // update the timer
          // check if less than 10 then we need to 
          // add '0' at the begining of the variable
          setTimer(
              (hours > 9 ? hours : '0' + hours) + ':' +
              (minutes > 9 ? minutes : '0' + minutes) + ':'
              + (seconds > 9 ? seconds : '0' + seconds)
          )
      }
  }



const clearTimer = (e) => {
  
  // If you adjust it you should also need to
  // adjust the Endtime formula we are about
  // to code next    
  setTimer('00:01:00');

  // If you try to remove this line the 
  // updating of timer Variable will be
  // after 1000ms or 1sec
  if (Ref.current) clearInterval(Ref.current);
  const id = setInterval(() => {
      startTimer(e);
  }, 1000)
  Ref.current = id;
  console.log(Ref.current = id)
}

const getDeadTime = () => {
  let deadline = new Date();

  // This is where you need to adjust if 
  // you entend to add more time
  deadline.setSeconds(deadline.getSeconds() + 60);
  console.log("deadline",deadline)
  return deadline;

}

useEffect(() => {
  clearTimer(getDeadTime());
}, []);

useEffect(() => {
  if(timer === '00:00:00'){
    console.log("Times up! do API CALL");
    setIsTimeup(true)
  }

}, [timer]);

  const bookingDetails = () => {
    const serviceInfo = availableServices.filter(
      (selectedService) => service.id === selectedService._id
    );
    let serviceDetials = {
      name: serviceInfo[0].name,
      location: serviceInfo[0].name,
      date: date,
      time: time,
    };

    return (
      <BookingInfo
        serviceName={serviceDetials.name}
        location={serviceInfo[0].location}
        time={serviceDetials.time}
        date={serviceDetials.date.toDateString()}
      />
    );
  };
  return (
    <Grid
      stackable
      columns={2}
      textAlign="center"
      style={{ marginTop: "auto", marginBottom: "auto" ,padding:"0 1rem"}}
      verticalAlign="middle"
    >
      <GridRow><Header as="h2"> You have {timer} to confirm!</Header> </GridRow>
      {bookingDetails()}
      <BookingForm />
      <ModalBuilder isTimeUp={isTimeUp} setPage={setPage}/>
    </Grid>
  );
};

export default StepThree;
